<template>
  <div class="login-shell">
    <div class="login-left">
      <div class="brand">
        <img src="../assets/images/logo_branca_bi.png" :alt="$t('ginfo_analytics')" class="brand-logo">
      </div> 

      <language-switter v-if="validaLink" class="lang-pill"></language-switter>

      <div class="quote">
        <p>
          <span class="linha-prefixo">{{ textoPrefixo }}</span>
          <span class="linha-sufixo"><span class="destaque">{{ textoSufixo }}</span><span class="cursor-digitacao">|</span></span>
        </p>
        <small>— {{ $t('ginfo_analytics') }}</small>
      </div>
    </div>

    <div class="login-right">
      <div class="login-card">
        <h1>{{ $t('bem_vindo') }}<br> {{ $t('ginfo_analytics') }}</h1>
        <p class="subtitle">{{ $t('Entre com suas credenciais') }} {{ $t('do Ginfo abaixo') }}</p>

        <form>
          <div class="campo">
            <label for="inputEmpresa">{{ $t('empresa_login') }}</label>
            <v-select id="inputEmpresa" :options="empresas" v-model="empresaSelecionada"
              @input="setEmpresaLogin(empresaSelecionada)" :placeholder="$t('Selecione a empresa')" />
          </div>

          <div class="campo"
            v-if="empresaSelecionada && (empresaSelecionada.name === 'AB-INBEV' || empresaSelecionada.name === 'ZONE' || empresaSelecionada.name === 'GINFO_EUROPA')">
            <label for="inputPais">{{ $t('PAIS') }}</label>
            <v-select id="inputPais" :options="paisesOpcoes" v-model="paisSelecionado"
              :placeholder="$t('SELECIONE_O_PAIS')" />
          </div>

          <div class="campo">
            <label for="email">{{ $t('E-mail') }}</label>
            <div class="input-wrap">
              <i class="bi bi-envelope"></i>
              <input type="email" id="email" v-model="login" @keyup.enter="doLogin()">
            </div>
          </div>

          <div class="campo">
            <label for="password">{{ $t('Senha') }}</label>
            <div class="input-wrap">
              <i class="bi bi-lock"></i>
              <input :type="mostrarSenha ? 'text' : 'password'" id="password" placeholder="********" v-model="senha"
                @keyup.enter="doLogin()">
              <i
                class="bi toggle-senha"
                :class="mostrarSenha ? 'bi-eye-slash' : 'bi-eye'"
                :title="mostrarSenha ? $t('ocultar_senha') : $t('mostrar_senha')"
                @click="mostrarSenha = !mostrarSenha"
              ></i>
            </div>
          </div>

          <div class="linha-opcoes">
            <label class="chk">
              <input type="checkbox" id="remember" v-model="lembrarUser">
              {{ $t('Lembrar de mim') }}
            </label>
            <!-- <a class="link-esqueci" href="https://inove.tomticket.com" target="_blank">{{ $t('esqueceu_senha') }}</a> -->
          </div>

          <button type="button" class="btn-primario" id="btnLogin" @click="doLogin()">{{ $t('Entrar') }}</button>
          <a class="btn-secundario" href="https://ginfo.inovess.com.br/Pages/solicitar.php" target="_blank">{{ $t('Solicite seu acesso') }}!</a>
        </form>
      </div>
    </div>

    <modal-avaliacao :pesquisa="pesquisa"></modal-avaliacao>
  </div>
</template>
<script>
/* eslint-disable */
import ModalAvaliacao from '@/components/Modais/ModalAvaliacao.vue'
import LanguageSwitter from '@/components/LanguageSwitter.vue';
import api from '@/common/api.js';
export default {
  name: 'LoginView',
  data() {
    return {
      empresa: '',
      empresaSelecionada: '',
      paisSelecionado: '',
      login: '',
      senha: '',
      lembrarUser: false,
      mostrarSenha: false,
      options: ['Opção 1', 'Opção 2', 'Opção 3'],
      empresaSelected: '',
      pesquisa: {},
      empresasBloqueadas: ["VITORIALOG"],

      textoPrefixo: '',
      textoSufixo: '',
      indiceFrase: 0,
      animacaoDestruida: false,
      timerDigitacao: null,

    }
  },
  created(){
    this.$store.dispatch('busca/getEmpresasBusca')
    this.empresaSelecionada = this.getEmpresaLogada()

    this.verificarSaveLogin()
  },
  mounted(){
    this.iniciarAnimacaoFrase()
  },
  beforeDestroy(){
    this.animacaoDestruida = true
    if (this.timerDigitacao) clearTimeout(this.timerDigitacao)
  },
  components: {
    ModalAvaliacao,
    LanguageSwitter
  },
  computed: {
    validaLink() {
      const host = window.location.hostname;

      if(host.includes('ginfo.io')) {
        this.$i18n.locale = 'en';
        this.open = false;

        const idiomaSelecionado = {
          lang: 'en'
        }
        localStorage.lang = JSON.stringify(idiomaSelecionado)

        return false;
      }

      return host.includes('localhost');
    },
    frasesRotativas() {
      return [
        this.$t('login_frase_destaque'),
        this.$t('login_frase_2'),
        this.$t('login_frase_3')
      ]
    },
    getEmpresas(){
      const empresas = this.$store.getters['busca/getEmpresas']

      if(!empresas){

        return []
      }

      return empresas
    },
    empresas() {
      let empresas = this.$store.getters['busca/getEmpresas']

      if (!Array.isArray(empresas) || empresas.length === 0) {

        return []
      }

      return empresas
        .filter(empresa => !this.empresasBloqueadas.includes(empresa.name)) // remove bloqueadas
        .map(empresa => ({
          ...empresa,
          label: empresa.name.toUpperCase()
        }))
    },
    paisesOpcoes() {
      let empresas = this.$store.getters['busca/getEmpresas']

      if (!Array.isArray(empresas) || empresas.length === 0) {
        return []
      }

      let paises = empresas
        .filter(empresa => empresa.name !== 'AB-INBEV' && empresa.name !== 'GINFO_EUROPA' && empresa.name !== 'ZONE' && !this.empresasBloqueadas.includes(empresa.name))
        .map(empresa => ({
          ...empresa,
          label: empresa.name.toUpperCase()
        }));

      paises.unshift({ name: 'TODOS', label: this.$t('TODOS') });
      return paises;
    }
  },
  watch: {
    empresas(newVal) {
      if (newVal && newVal.length > 0 && this.empresaSelecionada && this.empresaSelecionada.name) {
        const found = newVal.find(e => e.name === this.empresaSelecionada.name);
        if (found && this.empresaSelecionada !== found) {
          this.empresaSelecionada = found;
        }
      }
    }
  },
  methods:{
    esperar(ms) {
      return new Promise(resolve => {
        this.timerDigitacao = setTimeout(resolve, ms)
      })
    },
    digitar(texto, aoAtualizar) {
      return new Promise(resolve => {
        let i = 0
        const passo = () => {
          if (this.animacaoDestruida) return resolve()

          aoAtualizar(texto.slice(0, i))
          i++

          if (i <= texto.length) {
            this.timerDigitacao = setTimeout(passo, 50)
          } else {
            resolve()
          }
        }
        passo()
      })
    },
    apagar(texto, aoAtualizar) {
      return new Promise(resolve => {
        let i = texto.length
        const passo = () => {
          if (this.animacaoDestruida) return resolve()

          aoAtualizar(texto.slice(0, i))
          i--

          if (i >= 0) {
            this.timerDigitacao = setTimeout(passo, 30)
          } else {
            resolve()
          }
        }
        passo()
      })
    },
    async iniciarAnimacaoFrase() {
      const reduzirMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (reduzirMovimento) {
        this.textoPrefixo = this.$t('login_frase_inicio') + ' '
        this.textoSufixo = this.frasesRotativas[0]
        return
      }

      await this.digitar(this.$t('login_frase_inicio') + ' ', texto => { this.textoPrefixo = texto })

      while (!this.animacaoDestruida) {
        const frases = this.frasesRotativas
        const frase = frases[this.indiceFrase % frases.length]

        await this.digitar(frase, texto => { this.textoSufixo = texto })
        if (this.animacaoDestruida) break

        await this.esperar(1500)
        if (this.animacaoDestruida) break

        await this.apagar(frase, texto => { this.textoSufixo = texto })
        if (this.animacaoDestruida) break

        this.indiceFrase++
        await this.esperar(300)
      }
    },
    verificarSaveLogin(){
      try {
        const cookieLogin = JSON.parse(localStorage.saveLogin)

        // this.empresaSelecionada = cookieLogin.empresa,
        this.login = cookieLogin.email,
        this.senha = cookieLogin.senha
        this.lembrarUser = cookieLogin.lembrarUser
      } catch (error) {
      }
    },
    async setEmpresaLogin(empresa) {

      console.log(empresa)

      if (empresa == null) {
        empresa = 'Selecione uma empresa'
      } else if (empresa && empresa.key) {
        api.defaults.headers.common['ApiKey'] = empresa.key;
      }

      const requiresCountry = empresa.name === 'AB-INBEV' || empresa.name === 'GINFO_EUROPA' || empresa.name === 'ZONE';

      try {
        const cookieEmpresa = JSON.parse(localStorage.empresa)

        if (cookieEmpresa == "Selecione uma empresa") {
          localStorage.empresa = JSON.stringify(empresa)
          if (!requiresCountry) window.location.reload()
          return
        }

        localStorage.empresa = JSON.stringify(empresa)
      } catch (error) {
        localStorage.empresa = JSON.stringify(empresa)
        if (!requiresCountry) window.location.reload()
      }

      if (!requiresCountry) window.location.reload()

      // this.functionDisabledCookie()
    },
    getEmpresaLogada() {
      try {
        if (localStorage.empresa != undefined) {
          const cookieEmpresa = JSON.parse(localStorage.empresa)
          console.log(cookieEmpresa)
          if (cookieEmpresa) {
            var empresa = cookieEmpresa
          }

          return empresa
        }
      } catch (error) {
        return ''
      }
    },
    doLogin(){
      let empresaParaLogin = this.empresaSelecionada;

      if (this.empresaSelecionada && (this.empresaSelecionada.name === 'AB-INBEV' || this.empresaSelecionada.name === 'GINFO_EUROPA' || this.empresaSelecionada.name === 'ZONE')) {
        if (this.paisSelecionado && this.paisSelecionado.name !== 'TODOS') {
          localStorage.setItem('paisSelecionado', this.paisSelecionado.name);
        } else {
          localStorage.removeItem('paisSelecionado');
        }
      } else {
        localStorage.removeItem('paisSelecionado');
      }

      const data = {
        ds_empresa: empresaParaLogin.name,
        email: this.login,
        senha: this.senha,
        empresa: empresaParaLogin,
        lembrarUser: this.lembrarUser
      }

      const btnLogin = document.getElementById('btnLogin')

      btnLogin.innerText = this.$t('Carregando')

      this.$store.dispatch('busca/doLogin', {data: data}).then((response) => {

        // Valida se é necessário fazer NPS
        console.log(response.data.pesquisa_nps)

        if(response.data.realiza_pesquisa_nps) {
          $('#modal-avaliacao').modal('show');
          this.pesquisa = {
            tecnicoId: response.data.tecnicoId,
            nr_seq_pesquisa: response.data.pesquisa_nps[0].nr_sequencial,
            loginExterno: false
          }

        } else {
          if(this.lembrarUser){
            const jsonLogin = JSON.stringify(data)
            localStorage.setItem('saveLogin', jsonLogin);
          }

          window.location = '/bi/inicio'
          btnLogin.innerText = this.$t('Entrar')
          this.$store.commit('busca/setBemVindo', true)
        }

      }).catch(e => {
        this.$swal.fire({
          title: "Oops!",
          text: this.$t("Login incorreto, insira as informações novamente"),
          icon: "error"
        })
        btnLogin.innerText = this.$t('Entrar')
      })
    }
  }
}
</script>
<style scoped>
.login-shell {
  width: 100%;
  min-height: 100vh;
  display: flex;
  background: var(--rd-bg-app);
  color: var(--rd-text-1);
}

.login-left {
  flex: 1.15;
  display: flex;
  flex-direction: column;
  padding: 30px 40px;
  position: relative;
  min-width: 0;
}

.brand {
  display: flex;
  align-items: center;
}

.brand-logo {
  max-height: 90px;
}

.lang-pill {
  position: absolute;
  top: 30px;
  right: 40px;
}

.quote {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 480px;
  margin-left: 25%;
}

.quote p {
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 18px;
}

.linha-prefixo,
.linha-sufixo {
  display: block;
  font-size: 35px;
}

.destaque {
  color: var(--rd-accent);
}

.cursor-digitacao {
  color: var(--rd-accent);
  font-weight: 400;
  margin-left: 1px;
  animation: piscar-cursor 1s step-start infinite;
}

@keyframes piscar-cursor {
  50% {
    opacity: 0;
  }
}

.quote small {
  color: var(--rd-text-3);
  font-size: 13px;
}

.login-right {
  width: 380px;
  min-width: 380px;
  background: var(--rd-bg-1);
  border-left: 1px solid var(--rd-border);
  display: flex;
  align-items: center;
  padding: 40px;
  background: #1a1b22!important;
}

.login-card {
  width: 100%;
}

.login-card h1 {
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 6px;
  line-height: 1.3;
}

.subtitle {
  color: var(--rd-text-2);
  font-size: 13px;
  margin: 0 0 26px;
}

.campo {
  margin-bottom: 16px;
  text-align: left;
}

.campo label {
  display: block;
  font-size: 12px;
  color: var(--rd-text-3);
  margin-bottom: 6px;
}

.input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius-sm);
  padding: 9px 12px;
}

.input-wrap:focus-within {
  border-color: var(--rd-border-strong);
}

.input-wrap i {
  color: var(--rd-text-3);
  font-size: 15px;
}

.input-wrap i.toggle-senha {
  cursor: pointer;
}

.input-wrap i.toggle-senha:hover {
  color: var(--rd-text-1);
}

.input-wrap input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--rd-text-1);
  font-size: 13.5px;
}

.linha-opcoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0 22px;
}

.chk {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--rd-text-2);
  font-size: 12.5px;
  cursor: pointer;
}

.chk input {
  accent-color: var(--rd-accent);
}

.link-esqueci {
  color: var(--rd-text-2);
  font-size: 12.5px;
}

.link-esqueci:hover {
  color: var(--rd-text-1);
}

.btn-primario {
  display: block;
  width: 100%;
  border: none;
  border-radius: var(--rd-radius-sm);
  padding: 11px;
  text-align: center;
  font-size: 13.5px;
  font-weight: 500;
  background: var(--rd-accent);
  color: #06121f;
  cursor: pointer;
  margin-bottom: 10px;
}

.btn-primario:hover {
  opacity: 0.9;
}

.btn-secundario {
  display: block;
  width: 100%;
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-sm);
  padding: 10px;
  text-align: center;
  font-size: 13.5px;
  color: var(--rd-text-2);
}

.btn-secundario:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

@media (max-width: 860px) {
  .login-shell {
    flex-direction: column;
  }

  .login-left {
    display: none;
  }

  .login-right {
    
    width: 100%;
    min-width: 0;
    border-left: none;
    padding: 30px 24px;
  }
}
</style>
<style>
.login-right .v-select {
  min-height: 40px;
  border: 1px solid var(--rd-border);
  border-radius: var(--rd-radius-sm);
  background-color: var(--rd-bg-2);
}

.login-right .v-select .vs__dropdown-toggle {
  border: none;
  padding: 2px 4px;
  background: #1a1b22!important;

}

.login-right .v-select .vs__search,
.login-right .v-select .vs__selected {
  color: var(--rd-text-1);
  font-size: 13.5px;
}

.login-right .v-select .vs__search::placeholder {
  color: var(--rd-text-3);
}

.login-right .v-select .vs__dropdown-toggle:focus,
.login-right .v-select .vs__dropdown-toggle:focus-within {
  box-shadow: none;
  border-color: var(--rd-border-strong);
}

.login-right .v-select .vs__actions .vs__clear,
.login-right .v-select .vs__actions .vs__open-indicator {
  fill: var(--rd-text-3);
}

.login-right .v-select .vs__dropdown-menu {
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  color: var(--rd-text-1);
}

.login-right .v-select .vs__dropdown-option {
  color: var(--rd-text-1);
}

.login-right .v-select .vs__dropdown-option--highlight {
  background: var(--rd-accent);
  color: #06121f;
}
</style>
